
        <ig-page-spinner [loadingTip]="'Redirecting to Google Map...'"></ig-page-spinner>
    


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/gps.redirect.component.ts.GpsRedirectComponent.html